(function($) {
    /**
     * Menu script
     */
    class CreationsPaint_Slider {
        constructor() {
            this.initEvents();
        }
    
        initEvents() {
            let sliderWrapper = $('.header-slider-wrapper');
            let dots = sliderWrapper.find('.dot');
            let nextBtn = sliderWrapper.find('.next');
    
            setTimeout(() => {
                showNextSlide();
            }, 4500);
    
            if (sliderWrapper.length) {
                let list = sliderWrapper.find('.slider-list');
                let items = list.find('.slider-item');
                let currentItem = 0;
                let animationInProgress = false;
    
                nextBtn.on('click', function(e) {
                    e.preventDefault();
    
                    if (animationInProgress) {
                        return;
                    }
    
                    currentItem++;
                    animationInProgress = true;
    
                    if (currentItem >= items.length) {
                        currentItem = 0;
                    }
    
                    dots.removeClass('is-active');
                    dots.eq(currentItem).addClass('is-active');
                    list.css('margin-left', (-100 * currentItem) + "%");
    
                    setTimeout(function() {
                        animationInProgress = false;
                    }, 550);
                });
    
                for (let i = 0; i < dots.length; i++) {
                    dots.eq(i).on('click', e => {
                        e.preventDefault();
    
                        if (animationInProgress) {
                            return;
                        }
    
                        currentItem = i;
                        animationInProgress = true;
                        dots.removeClass('is-active');
                        dots.eq(currentItem).addClass('is-active');
                        list.css('margin-left', (-100 * currentItem) + "%");
                        
                        setTimeout(function() {
                            animationInProgress = false;
                        }, 550);
                    });
                }
            }
    
            function showNextSlide () {
                nextBtn.trigger('click');
    
                setTimeout(() => {
                    showNextSlide();
                }, 4500);
            }
        }
    }
    
    /**
     * Menu script
     */
    class CreationsPaint_Menu {
        constructor() {
            this.initEvents();
        }
    
        initEvents() {
            var menuWrapper = $('.menu-top-bar');
            var menuIcon = menuWrapper.find('.menu-toggle');
            var menuBlock = menuWrapper.find('.menu-block');
    
            if (menuIcon.length) {
                menuIcon.on('click', function (e) {
                    e.preventDefault();
                    menuBlock.toggleClass('is-active');
    
                    setTimeout(function () {
                        menuBlock.toggleClass('is-showing');
                    }, 150);
                });
            }
        }
    }
    
    /**
     * Testimonials slider script
     */
    class CreationsPaint_Testimonials {
        constructor() {
            this.initEvents();
        }
    
        initEvents() {
            let sliderWrapper = $('.block-testimonials');
            let nextBtn = sliderWrapper.find('.next');
    
            setTimeout(() => {
                showNextSlide();
            }, 4500);
    
            if (sliderWrapper.length) {
                let list = sliderWrapper.find('.testimonial-list');
                let items = list.find('.testimonial-item');
                let currentItem = 0;
                let animationInProgress = false;
    
                nextBtn.on('click', function(e) {
                    e.preventDefault();
    
                    if (animationInProgress) {
                        return;
                    }
    
                    currentItem++;
                    animationInProgress = true;
    
                    if (currentItem >= items.length) {
                        currentItem = 0;
                    }
    
                    items.removeClass('is-active');
                    setTimeout(function() {
                        items.eq(currentItem).addClass('is-active');
                    }, 550);
    
                    setTimeout(function() {
                        animationInProgress = false;
                    }, 550);
                });
            }
    
            function showNextSlide () {
                nextBtn.trigger('click');
    
                setTimeout(() => {
                    showNextSlide();
                }, 4500);
            }
        }
    }

    new CreationsPaint_Slider();
    new CreationsPaint_Menu();
    new CreationsPaint_Testimonials();
})(jQuery);